import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// ASSETS
import watchChannelsImg from '@/assets/images/watch-channels.png';

// STYLES
import DialogCTAStyled from './styles';

const DialogLessChannels = props => {
  const { onClose } = props;

  const isMobile = useMediaQuery(({ breakpoints }) => breakpoints.down('sm'));
  const [t] = useTranslation();

  const title = t('channels.lessChannels.title');
  const subtitle = <Trans i18nKey="channels.lessChannels.subtitle" components={{ b: <b /> }} />;

  return (
    <DialogCTAStyled
      {...props}
      hideCancelButton
      className="less-channels"
      image={<img src={watchChannelsImg} alt="" />}
      title={title}
      titleProps={{
        align: 'center',
        variant: isMobile ? 'h5' : 'h3',
      }}
      subtitle={subtitle}
      subtitleProps={{
        className: isMobile && 'p4',
      }}
      buttonConfirmProps={{
        onClick: onClose,
      }}
      buttonConfirmTitle={t('buttons.gotIt')}
    />
  );
};

DialogLessChannels.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default DialogLessChannels;
